import { httpRequest } from "../../http";

export class CommandUpdateEngagement {
    async run(engagementId: number, organizationId: number) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/`
        try {
            const response = await httpRequest<any>(url, { method: "PUT", body: {
                "organization":{
                  "id": organizationId
                }
              } });
            //TODO ADD SERIALIZER
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    // deserialize(data: any) : EngagementTeam []{
    //     const serializer = new EngagementTeamSerializer();
    //     return serializer.deserializeList(data);
    // }
}

